<template>
  <AdminShell>
    <div class="head">
      <h2>Create User</h2>
      <router-link to="/admin/users" class="btn ghost">Back</router-link>
    </div>

    <form class="form" @submit.prevent="submit">

      <div class="grid">

        <div class="field">
          <label>Username</label>
          <input v-model="form.username" required />
        </div>

        <div class="field">
          <label>Password</label>
          <input type="password" v-model="form.password" required />
        </div>

        <div class="field">
          <label>Role</label>
          <select v-model="form.role" required>
            <option value="">Select Role</option>
            <option value="admin">Admin</option>
            <option value="manager">Manager</option>
            <option value="agent">Agent</option>
          </select>
        </div>

        <div class="field">
          <label>Tenant</label>
          <select v-model="form.tenant_id">
            <option value="">Select Tenant</option>
            <option v-for="t in tenants" :key="t.id" :value="t.id">
              {{ t.name }}
            </option>
          </select>
        </div>

        <div class="field full">
          <label>
            <input type="checkbox" v-model="form.is_active" />
            Active
          </label>
        </div>

      </div>

      <div class="actions">
        <button type="submit" class="btn">Create User</button>
      </div>

    </form>
  </AdminShell>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import AdminShell from "@/components/admin/AdminShell.vue";
import { createUser, getTenants } from "@/services/admin";
import { showToast } from "@/services/toast";

const router = useRouter();

const form = ref({
  username: "",
  password: "",
  role: "",
  tenant_id: "",
  is_active: true
});

const tenants = ref([]);

onMounted(async () => {
  try {
    const res = await getTenants();
    tenants.value = res.data?.tenants || [];
  } catch {
    showToast("Failed to load tenants", "error");
  }
});

async function submit() {
  try {
    const res = await createUser(form.value);

    if (!res.data?.ok) {
      showToast("Failed to create user", "error");
      return;
    }

    showToast("User created successfully ✅", "success");
    router.push("/admin/users");
  } catch (err) {
    console.error(err);
    showToast("Error creating user ❌", "error");
  }
}
</script>

<style scoped>
.head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
}

.form {
  background: white;
  padding: 20px;
  border-radius: 12px;
}

.grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.field.full {
  grid-column: span 2;
}

input,
select {
  height: 40px;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 0 10px;
}

.actions {
  margin-top: 20px;
}

.btn {
  background: #8b5cf6;
  color: white;
  border: none;
  padding: 10px 16px;
  border-radius: 10px;
  cursor: pointer;
}

.btn.ghost {
  background: #eee;
  color: #333;
}
</style>
